import styled from 'styled-components';

export const AddButtonStyled = styled.button`
    background: none;
    border: none;
    outline: none;
    font-size: 80px;
    color: #51AB76;
    transition: .3s ease all;

    &:hover {
        opacity: .3;
    }

    @media screen and (max-width: 768px){
        font-size: 60px;
    }

    @media screen and (max-width: 576px){
        font-size: 40px;
    }
`;